<template>
  <div>
    <!-- Header Section -->
    <div class="row mb-4">
      <div class="col-md-8">
        <div class="d-flex align-items-center">
          <div class="bg-primary-light p-3 rounded-2 me-3">
            <vue-feather type="percent" class="d-flex justify-content-center align-content-center" stroke="#652aa3" size="24"></vue-feather>
          </div>
          <h3 class="mb-0 fw-bold">Commission Rates Management</h3>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex justify-content-end">
          <button
            v-if="profile.role !== 'user' && profile.role !== 'admin'"
            class="btn btn-primary shadow-sm"
            @click="commissionRateModal = true; commissionRateMode = 'add'"
          >
            <vue-feather type="plus" size="18" class="me-1"></vue-feather>
            Add Commission Rate
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <Card cardClasses="shadow-sm border-0 h-100 mb-4">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="font-size-125 color-gray-600">
              <vue-feather type="list" stroke="#652aa3" size="18" class="me-1"></vue-feather>
              Commission Rates ({{commissionRates.length}})
            </div>
            <div class="bg-primary-light p-2 rounded-circle">
              <vue-feather type="percent" class="d-flex justify-content-center align-content-center" stroke="#652aa3" size="20"></vue-feather>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-hover align-middle">
              <thead class="table-light">
                <tr>
                  <th scope="col" class="fw-semibold">Name</th>
                  <th scope="col" class="fw-semibold">Name(In Payslip)</th>
                  <th scope="col" class="fw-semibold">From Amount</th>
                  <th scope="col" class="fw-semibold">Rate</th>
                  <th scope="col" class="fw-semibold">Description</th>
                  <th scope="col" class="fw-semibold">Created</th>
                  <th scope="col" class="text-end">Actions</th>
                </tr>
              </thead>
              <tbody v-if="!loading">
                <tr v-for="commissionRate in commissionRates" :key="commissionRate.id" class="commission-rate-row">
                  <td class="fw-medium">{{ commissionRate.name }}</td>
                  <td class="fw-medium">{{ commissionRate.display_name }}</td>
                  <td>
                    <span class="badge bg-primary-light text-primary">{{ Ksh(commissionRate.amount) }}</span>
                  </td>
                  <td>{{ commissionRate.rate }}%</td>
                  <td>{{ commissionRate.description || 'Not specified' }}</td>
                  <td>{{ formatDate(commissionRate.created_at) }}</td>
                  <td class="text-end">
                    <button
                      v-if="profile.role !== 'user' && profile.role !== 'admin'"
                      class="btn btn-sm btn-outline-primary"
                      @click="commissionRateModal = true; commissionRateMode = 'edit'; populateCommissionRateEdit(commissionRate)"
                    >
                      <vue-feather type="edit-2" size="16"></vue-feather>
                      Edit
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="loading" class="text-center py-4">
              <Spinner spinner-class="mb-1" />
            </div>
            <div v-if="!loading && commissionRates.length === 0" class="text-center py-4">
              <div class="empty-state">
                <div class="bg-light p-4 rounded-circle mb-3 d-inline-block">
                  <vue-feather type="percent" size="32" stroke="#6c757d"></vue-feather>
                </div>
                <h5>No Commission Rates Found</h5>
                <p class="text-muted">Start by adding your first commission rate</p>
                <button
                  v-if="profile.role !== 'user' && profile.role !== 'admin'"
                  class="btn btn-primary"
                  @click="commissionRateModal = true; commissionRateMode = 'add'"
                >
                  <vue-feather type="plus" size="16" class="me-1"></vue-feather>
                  Add Commission Rate
                </button>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-center mt-4">
            <button class="btn btn-outline-dark text-uppercase me-4 shadow-sm" @click="$router.go(-1)">
              <vue-feather type="arrow-left" size="16" class="me-1"></vue-feather>
              Back
            </button>
          </div>
        </Card>
      </div>
    </div>

    <!-- Commission Rate Modal -->
    <Modal :open="commissionRateModal" @closed="commissionRateModal = false">
      <div class="modal-header border-0">
        <div class="d-flex align-items-center">
          <h5 class="modal-title m-0 fw-bold" v-if="commissionRateMode === 'add'">Add Commission Rate</h5>
          <h5 class="modal-title m-0 fw-bold" v-else>Edit Commission Rate</h5>
        </div>
        <button @click="commissionRateModal = false" type="button" class="btn-close outline-none" data-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="">
          <div class="row g-3">
            <div class="col-md-12 mb-2 h5">
              <label for="name" class="form-label fw-bolder">Commission Rate Name</label>
              <div class="input-group">
                <input
                  type="text"
                  id="name"
                  class="form-control"
                  placeholder="Enter commission rate name"
                  v-model="commissionRate.name"
                >
              </div>
            </div>
            <div class="col-md-12 mb-2 h5">
              <label for="name" class="form-label fw-bolder">Display Name</label>
              <div class="input-group">
                <input
                    type="text"
                    id="name"
                    class="form-control"
                    placeholder="Enter display name"
                    v-model="commissionRate.display_name"
                >
              </div>
              <span class="fs-6 fst-italic text-muted">This is the name that will be displayed in the payslip</span>
            </div>
            <div class="col-md-12 mb-2 h5">
              <label for="amount" class="form-label fw-bolder">From Amount</label>
              <div class="input-group">
                <input
                  type="number"
                  id="amount"
                  class="form-control"
                  placeholder="Enter amount threshold"
                  v-model="commissionRate.amount"
                >
              </div>
            </div>
            <div class="col-md-12 mb-2 h5">
              <label for="rate" class="form-label fw-bolder">Rate (%)</label>
              <div class="input-group">
                <input
                  type="number"
                  id="rate"
                  class="form-control"
                  placeholder="Enter rate percentage (0-100)"
                  v-model="commissionRate.rate"
                >
              </div>
            </div>
            <div class="col-md-12 mb-2 h5">
              <label for="description" class="form-label fw-bolder">Description <span class="text-muted">(optional)</span></label>
              <div class="input-group">
                <input
                  type="text"
                  id="description"
                  class="form-control"
                  placeholder="Enter commission rate description"
                  v-model="commissionRate.description"
                >
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer border-0 pt-0">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-dismiss="modal"
          @click="commissionRateModal = false"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          v-if="commissionRateMode === 'add'"
          @click="addCommissionRate($event)"
        >
          Save Commission Rate
        </button>
        <button
          type="button"
          class="btn btn-primary"
          v-else
          @click="updateCommissionRate($event, commissionRate.id)"
        >
          Update Commission Rate
        </button>
      </div>
    </Modal>
  </div>
</template>

<script>
import commissionRateService from "@/api/commissionRateService";
import formatDate from "../../utils/formatDate";
import Ksh from "@/utils/formatNumber";
import {decrypt} from "@/utils/crypto";
import loadingButton from "@/utils/loadingButton";
import VueFeather from 'vue-feather';

export default {
  name: "CommissionRates",
  components: { VueFeather },

  data(){
    return {
      profile: {},
      loading: true,
      commissionRates: [],
      commissionRateMode: 'add',
      commissionRateModal: false,
      commissionRate: {
        name: '',
        display_name: '',
        amount: '',
        rate: '',
        description: '',
      },
    }
  },

  methods: {
    Ksh,
    formatDate,
    async getCommissionRates() {
      this.loading = true
      try {
        this.commissionRates = await commissionRateService.getCommissionRates()
      } catch (error) {
        console.error("Error fetching commission rates:", error)
      } finally {
        this.loading = false
      }
    },

    populateCommissionRateEdit(commissionRate) {
      this.commissionRate = { ...commissionRate }
    },

    async addCommissionRate(e) {
      if (!this.commissionRate.name || !this.commissionRate.amount || !this.commissionRate.rate) {
        return
      }

      loadingButton(e)
      try {
        let response = await commissionRateService.createCommissionRate(this.commissionRate)
        if (response) {
          this.commissionRateModal = false
          await this.getCommissionRates()
        }
      } catch (error) {
        console.error("Error adding commission rate:", error)
      } finally {
        loadingButton(e, false)
      }
    },

    async updateCommissionRate(e, id) {
      if (!this.commissionRate.name || !this.commissionRate.amount || !this.commissionRate.rate) {
        return
      }

      loadingButton(e)
      try {
        let response = await commissionRateService.updateCommissionRate(this.commissionRate, id)
        if (response) {
          this.commissionRateModal = false
          await this.getCommissionRates()
        }
      } catch (error) {
        console.error("Error updating commission rate:", error)
      } finally {
        loadingButton(e, false)
      }
    }
  },

  created: async function () {
    this.profile = JSON.parse(decrypt(sessionStorage.getItem('profile')))
    await this.getCommissionRates()
    if(this.$route.query.add)
      this.commissionRateModal = true
  },

  watch: {
    commissionRateModal: function () {
      if (!this.commissionRateModal) {
        this.commissionRate = {
          name: '',
          display_name: '',
          amount: '',
          rate: '',
          description: '',
        }
      }
    },
  }
}
</script>

<style scoped>
.bg-primary-light {
  background-color: rgba(101, 42, 163, 0.1);
}

.text-primary {
  color: #652aa3 !important;
}

.commission-rate-row {
  transition: all 0.2s ease;
}

.commission-rate-row:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

.empty-state {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.font-size-125 {
  font-size: 1.25rem;
}

.color-gray-600 {
  color: #6c757d;
}

.card {
  transition: all 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.btn {
  transition: all 0.2s ease;
}

.btn:hover {
  transform: translateY(-2px);
}

.input-group {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  border-radius: 0.25rem;
}

.input-group:focus-within {
  box-shadow: 0 2px 10px rgba(101, 42, 163, 0.15);
}
</style>
